/**
 * Emoji data — shared categories and keyword lookup for the web emoji picker.
 * Used by EmojiPicker component in comments, chat, and post creation.
 */

export interface EmojiCategory {
  id: string;
  label: string;
  labelKey: string;
  emojis: string[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smileys', label: 'Smileys & People', labelKey: 'emoji.categories.smileys',
    emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙', '🥲', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '😎', '🤓', '🧐', '😕', '😟', '🙁', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱', '😤', '😡', '😠', '🤬', '😈', '👿', '💀', '🤡', '👻', '👽', '🤖'],
  },
  {
    id: 'gestures', label: 'Gestures & Body', labelKey: 'emoji.categories.gestures',
    emojis: ['👍', '👎', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '👋', '🤚', '🖐️', '✋', '🖖', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪', '🦾', '🦿', '🦵', '🦶', '👂', '🦻', '👃', '🧠', '🫀', '🦷', '🦴', '👀', '👁️', '👅', '👄', '💋'],
  },
  {
    id: 'hearts', label: 'Hearts & Symbols', labelKey: 'emoji.categories.hearts',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '✨', '⭐', '🌟', '💫', '🔥', '💥', '💯', '💢', '💦', '💨', '🎉', '🎊', '🎁', '🏆', '🥇', '🥈', '🥉'],
  },
  {
    id: 'animals', label: 'Animals & Nature', labelKey: 'emoji.categories.animals',
    emojis: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐞', '🐜', '🦗', '🕷️', '🦂', '🐢', '🐍', '🦎', '🦖', '🐙', '🦑', '🦐', '🦞', '🦀', '🐠', '🐟', '🐬', '🐳', '🐋', '🦈', '🐊', '🐅', '🐆', '🦓', '🦍', '🦧', '🐘', '🦛', '🦏', '🐪', '🐫', '🦒', '🦘', '🐃', '🐂', '🐄', '🐎', '🐖', '🐏', '🐑', '🦙', '🐐', '🦌', '🐕', '🐩', '🦕', '🌵', '🎄', '🌲', '🌳', '🌴', '🌱', '🌿', '☘️', '🍀', '🎍', '🎋', '🍃', '🍂', '🍁', '🍄', '🌾', '💐', '🌷', '🌹', '🥀', '🌺', '🌸', '🌼', '🌻'],
  },
  {
    id: 'food', label: 'Food & Drink', labelKey: 'emoji.categories.food',
    emojis: ['🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑', '🥦', '🥬', '🥒', '🌶️', '🫑', '🌽', '🥕', '🧄', '🧅', '🥔', '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳', '🧈', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🦴', '🌭', '🍔', '🍟', '🍕', '🥪', '🥙', '🧆', '🌮', '🌯', '🫔', '🥗', '🥘', '🫕', '🥫', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🦪', '🍤', '🍙', '🍚', '🍘', '🍥', '🥠', '🥮', '🍢', '🍡', '🍧', '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫', '🍿', '🍩', '🍪', '🌰', '🥜', '🍯', '🥛', '🍼', '☕', '🫖', '🍵', '🍶', '🍾', '🍷', '🍸', '🍹', '🍺', '🍻', '🥂', '🥃', '🥤', '🧋', '🧃', '🧉', '🧊'],
  },
  {
    id: 'activities', label: 'Activities & Sports', labelKey: 'emoji.categories.activities',
    emojis: ['⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🪃', '🥅', '⛳', '🪁', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛼', '🛷', '⛸️', '🥌', '🎿', '⛷️', '🏂', '🪂', '🏋️', '🤼', '🤸', '🤺', '⛹️', '🤾', '🏌️', '🏇', '🧘', '🏄', '🏊', '🤽', '🚣', '🧗', '🚵', '🚴', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖️', '🏵️', '🎗️', '🎫', '🎟️', '🎪', '🤹', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🪘', '🎷', '🎺', '🪗', '🎸', '🪕', '🎻', '🎲', '♟️', '🎯', '🎳', '🎮', '🎰', '🧩'],
  },
];

/* ─── Emoji keyword lookup for search ────────────────────────────────── */
/* Keys are emoji characters; values are space-separated searchable words. */
export const EMOJI_KEYWORDS: Record<string, string> = {
  '😀': 'grin happy smile face', '😃': 'happy smile grin', '😄': 'happy smile grin', '😁': 'grin happy',
  '😆': 'laugh happy', '😅': 'sweat laugh happy', '🤣': 'rofl laugh cry', '😂': 'laugh cry joy happy',
  '🙂': 'smile happy', '🙃': 'upside smile', '😉': 'wink happy', '😊': 'smile blush happy',
  '😇': 'angel halo', '🥰': 'love heart adore', '😍': 'love heart eyes', '🤩': 'star excited wow',
  '😘': 'kiss love', '😋': 'yummy tasty delicious', '😛': 'tongue playful', '😜': 'wink tongue playful',
  '🤪': 'crazy silly', '🤔': 'think ponder', '🤐': 'quiet zip', '🤨': 'skeptical suspicious',
  '😐': 'neutral blank', '😑': 'expressionless blank', '😶': 'silent quiet', '😏': 'smirk',
  '😒': 'unamused bored', '🙄': 'roll eyes annoyed', '😬': 'grimace awkward', '😌': 'relieved calm',
  '😔': 'sad pensive', '😪': 'sleepy tired', '🤤': 'drool hungry', '😴': 'sleep tired',
  '😷': 'mask sick', '🤒': 'sick thermometer', '🤕': 'hurt bandage injured', '🤢': 'nausea sick green',
  '🤮': 'sick vomit', '😎': 'cool sunglasses', '🤓': 'nerd geek', '🧐': 'monocle inspect',
  '😕': 'confused', '😟': 'worried', '🙁': 'sad frown', '😮': 'surprised gasp', '😯': 'surprised',
  '😲': 'astonished shocked', '😳': 'flushed embarrassed', '🥺': 'pleading beg cute', '😨': 'fearful scared',
  '😰': 'anxious sweat', '😥': 'sad sweat', '😢': 'cry sad', '😭': 'cry sob sad',
  '😱': 'scream scared', '😖': 'confounded', '😣': 'persevere', '😞': 'disappointed sad',
  '😓': 'sweat sad', '😩': 'weary tired', '😫': 'tired exhausted', '🥱': 'yawn tired',
  '😤': 'huff angry', '😡': 'angry rage', '😠': 'angry', '🤬': 'curse angry',
  '😈': 'devil horns', '👿': 'devil angry', '💀': 'skull dead',
  '🤡': 'clown', '👻': 'ghost spooky', '👽': 'alien', '🤖': 'robot',
  '👍': 'thumbs up yes good like', '👎': 'thumbs down no dislike', '👌': 'ok okay good',
  '✌️': 'peace victory', '🤞': 'fingers crossed luck', '🤟': 'love you rock',
  '🤘': 'rock horns', '👈': 'point left', '👉': 'point right', '👆': 'point up',
  '👇': 'point down', '👋': 'wave hello hi', '✋': 'stop hand', '👏': 'clap applause',
  '🙌': 'raise hands celebrate', '🤝': 'handshake deal', '🙏': 'pray thanks please',
  '💪': 'muscle strong flex', '🦾': 'arm mechanical strong', '👀': 'eyes look watch', '👅': 'tongue', '👄': 'mouth lips', '💋': 'kiss lips',
  '❤️': 'heart love red', '🧡': 'heart orange love', '💛': 'heart yellow love', '💚': 'heart green love',
  '💙': 'heart blue love', '💜': 'heart purple love', '🖤': 'heart black love', '🤍': 'heart white love',
  '🤎': 'heart brown love', '💔': 'heart broken love sad', '💕': 'hearts love', '💞': 'hearts love',
  '💓': 'heart beat love', '💗': 'heart love', '💖': 'sparkle heart love', '💘': 'heart arrow love',
  '💝': 'heart ribbon gift love', '✨': 'sparkle shine', '⭐': 'star', '🌟': 'star glow',
  '💫': 'dizzy star', '🔥': 'fire hot lit', '💥': 'boom explosion', '💯': 'hundred perfect score',
  '🎉': 'party celebrate', '🎊': 'confetti celebrate', '🎁': 'gift present', '🏆': 'trophy win champion',
  '🥇': 'gold first', '🥈': 'silver second', '🥉': 'bronze third',
  '🐶': 'dog puppy', '🐱': 'cat kitten', '🐭': 'mouse', '🐹': 'hamster', '🐰': 'rabbit bunny',
  '🦊': 'fox', '🐻': 'bear', '🐼': 'panda', '🐨': 'koala', '🐯': 'tiger', '🦁': 'lion',
  '🐮': 'cow', '🐷': 'pig', '🐸': 'frog', '🐵': 'monkey', '🐔': 'chicken', '🐧': 'penguin',
  '🐦': 'bird', '🦅': 'eagle', '🦉': 'owl', '🐺': 'wolf', '🐴': 'horse', '🦄': 'unicorn',
  '🐝': 'bee', '🦋': 'butterfly', '🐢': 'turtle', '🐍': 'snake', '🐙': 'octopus',
  '🐟': 'fish', '🐬': 'dolphin', '🐳': 'whale', '🦈': 'shark', '🐊': 'crocodile',
  '🐘': 'elephant', '🦒': 'giraffe', '🌵': 'cactus', '🌳': 'tree', '🌴': 'palm tree',
  '🌱': 'sprout plant', '🌿': 'herb plant', '🍀': 'clover luck', '🍂': 'leaf autumn fall',
  '🍁': 'maple leaf autumn fall', '🍄': 'mushroom', '💐': 'flowers bouquet', '🌷': 'tulip flower',
  '🌹': 'rose flower', '🌺': 'hibiscus flower', '🌸': 'cherry blossom flower', '🌼': 'daisy flower',
  '🌻': 'sunflower', '🍏': 'apple green', '🍎': 'apple red', '🍐': 'pear', '🍊': 'orange tangerine',
  '🍋': 'lemon', '🍌': 'banana', '🍉': 'watermelon', '🍇': 'grape', '🍓': 'strawberry berry',
  '🍒': 'cherry', '🍑': 'peach', '🥭': 'mango', '🍍': 'pineapple', '🥥': 'coconut',
  '🥝': 'kiwi', '🍅': 'tomato', '🍆': 'eggplant', '🥑': 'avocado', '🥦': 'broccoli',
  '🌶️': 'chili pepper hot', '🌽': 'corn', '🥕': 'carrot', '🥔': 'potato', '🍞': 'bread',
  '🧀': 'cheese', '🥚': 'egg', '🍳': 'egg fried', '🥞': 'pancake', '🧇': 'waffle',
  '🥓': 'bacon', '🥩': 'steak meat', '🍗': 'chicken drumstick', '🍖': 'meat bone',
  '🌭': 'hotdog', '🍔': 'burger hamburger', '🍟': 'fries chips', '🍕': 'pizza',
  '🥪': 'sandwich', '🌮': 'taco', '🌯': 'burrito', '🥗': 'salad', '🍝': 'pasta spaghetti',
  '🍜': 'ramen noodles', '🍲': 'soup pot', '🍛': 'curry rice', '🍣': 'sushi',
  '🍱': 'bento box', '🍤': 'shrimp prawn', '🍙': 'rice ball', '🍚': 'rice',
  '🍦': 'icecream dessert', '🧁': 'cupcake', '🍰': 'cake slice dessert', '🎂': 'birthday cake',
  '🍫': 'chocolate', '🍿': 'popcorn', '🍩': 'donut doughnut', '🍪': 'cookie',
  '🍯': 'honey', '🥛': 'milk glass', '☕': 'coffee', '🍵': 'tea green', '🍾': 'champagne bottle',
  '🍷': 'wine glass', '🍺': 'beer mug', '🍻': 'beer cheers', '🥂': 'cheers toast',
  '🥃': 'whiskey tumbler', '🥤': 'cup drink soda', '⚽': 'soccer football', '🏀': 'basketball',
  '🏈': 'football american', '⚾': 'baseball', '🎾': 'tennis', '🏐': 'volleyball',
  '🏉': 'rugby', '🎱': 'pool billiards', '🏓': 'ping pong table tennis', '🏸': 'badminton',
  '🏒': 'hockey ice', '🏑': 'hockey field', '🏏': 'cricket', '⛳': 'golf',
  '🎯': 'dart target bullseye', '🎮': 'game controller video', '🎲': 'dice game',
  '🧩': 'puzzle', '🎨': 'art palette paint', '🎬': 'movie clapper film', '🎤': 'microphone karaoke',
  '🎧': 'headphones music', '🎸': 'guitar music', '🎹': 'piano keyboard music', '🥁': 'drum music',
  '🎺': 'trumpet music', '🎻': 'violin music', '🏋️': 'weightlift exercise gym',
  '🏃': 'run exercise', '🧘': 'yoga meditation', '🏄': 'surf wave', '🏊': 'swim',
  '🚴': 'bike cycling', '🚵': 'mountain bike cycling', '🏇': 'horseback ride',
};

/**
 * Returns filtered categories based on search text.
 * When search is empty, returns all categories unchanged.
 */
export function filterEmojiCategories(search: string): EmojiCategory[] {
  if (!search.trim()) return EMOJI_CATEGORIES;
  const q = search.trim().toLowerCase();
  return EMOJI_CATEGORIES.map(cat => ({
    ...cat,
    emojis: cat.emojis.filter(e => {
      const kw = EMOJI_KEYWORDS[e];
      return kw ? kw.includes(q) : false;
    }),
  })).filter(cat => cat.emojis.length > 0);
}
